import { render, staticRenderFns } from "./selectElevator.vue?vue&type=template&id=1defe69e"
import script from "./selectElevator.vue?vue&type=script&lang=js"
export * from "./selectElevator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports